import { render, staticRenderFns } from "./task-strategy.vue?vue&type=template&id=2ad5cbba&scoped=true&"
import script from "./task-strategy.vue?vue&type=script&lang=js&"
export * from "./task-strategy.vue?vue&type=script&lang=js&"
import style0 from "./task-strategy.vue?vue&type=style&index=0&id=2ad5cbba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../accelerator-assessment-test-20260908/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad5cbba",
  null
  
)

export default component.exports